import { DataContext } from "@/types";
import { Data } from "../Data";
import { SettingsRegulationRegion } from "./SettingRegulationRegion";

export class SettingsRegulationRegionList extends Data {
  static instance: SettingsRegulationRegionList | null = null;
  regions: any;

  constructor(options: any) {
    const { apiUrl, ...otherOptions } = options;

    const apiOptions = {
      api: apiUrl,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...otherOptions
    };

    super(apiOptions);
    this.regions = [];
  }

  onDataReceived(data: any) {
    this.regions = [];
    data.regions.forEach((g: any, index: any) =>
      this.regions.push(new SettingsRegulationRegion(g))
    );
  }

  static onGetData(context: DataContext, options: any) {
    const { apiUrl } = options;
    return new Promise((resolve, reject) => {
      SettingsRegulationRegionList.instance = new SettingsRegulationRegionList({
        apiUrl,
        resolve,
        reject,
        context
      });
    });
  }

  static getSettingRegulationRegionList(context: DataContext, updateCache: boolean): Promise<SettingsRegulationRegionList> {
    return new Promise((resolve, reject) => {
      if (SettingsRegulationRegionList.instance && updateCache !== true)
        resolve(SettingsRegulationRegionList.instance);
      else
        SettingsRegulationRegionList.instance = new SettingsRegulationRegionList({
          resolve,
          reject,
          context
        });
    });
  }
}
